module.exports = __webpack_public_path__ + "src/assets/img/hxjs_jsjg_01@2x.3031bf7f.png";